export default __webpack_public_path__ + "static/media/PinwheelLink.f9640e25.svg";